export default "__VITE_ASSET__DJdifIYg__"